export default __webpack_public_path__ + "static/viinitie-banner-corporate-desktop-extra-wide.96f88e87a9d0862322812af9bb43b3ec.jpg";